import * as React from "react";
import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import { CustomTableHead } from "./CustomTableHead";
import { NewCustomTableBody } from "./NewCustomTableBody";
import { CustomTableBodyLoading } from "./CustomTableBodyLoading";
import _ from "lodash";

export default function NewCustomTable({
  headers = true,
  dataKeysAndRepr = [{}],
  dataItemRows,
  alignAction,
  handleRowClick,
  pageData,
  loading = false,
}) {
  // const action = dataKeysAndRepr.find(({ objKey }) => objKey === "action");
  const normalizedColumns = dataKeysAndRepr.map((col) => {
    // If already in old format
    if (col.objKey) return col;
  
    // If new DataGrid-like format
    return {
      objKey: col.field,
      repr: col.headerName,
      renderCell: col.renderCell, // 🔥 preserve custom render
    };
  });
  const action = normalizedColumns.find(({ objKey }) => objKey === "action");
  const actionExist = _.isEmpty(action);
  return (
    <TableContainer component={Paper}>
      <Table aria-label="customized table">
        {headers && (
          <CustomTableHead
            // data={dataKeysAndRepr.map(({ repr }) => repr)}
            data={normalizedColumns.map(({ repr }) => repr)}
            action={actionExist ? "" : action.objKey}
            alignAction={alignAction}
          />
        )}
        {loading ? (
      <CustomTableBodyLoading
        columns={dataKeysAndRepr.length}
      />
    ) : (
      <NewCustomTableBody
        dataItemRows={dataItemRows}
        // dataKeys={dataKeysAndRepr.map(({ objKey }) => objKey)}
        // dataKeys={normalizedColumns.map(({ repr }) => repr)}
        dataKeys={normalizedColumns.map(({ objKey }) => objKey)}
        columns={normalizedColumns}
        action={!actionExist}
        handleRowClick={handleRowClick}
        pageData={pageData}
      />
    )}
      </Table>
    </TableContainer>
  );
}